import { z } from 'zod';
export const CATEGORIES_COUT = {
  LABOR: 'Main-d’œuvre',
  PARTS: 'Pièces',
  SUBCONTRACT: 'Sous-traitance',
  TRANSPORT: 'Transport',
  OTHER: 'Autre',
} as const;
export const ETAPES_COUT = {
  ESTIMATED: 'Estimé',
  COMMITTED: 'Engagé',
  INVOICED: 'Facturé',
  VALIDATED: 'Validé',
  CANCELLED: 'Annulé',
} as const;
export const schemaCoutReseau = z
  .object({
    libelle: z.string().trim().min(3).max(200),
    categorie: z.enum(['LABOR', 'PARTS', 'SUBCONTRACT', 'TRANSPORT', 'OTHER']),
    montant: z.number().int().min(0).max(100000000000),
    intervention_id: z.string().uuid().nullable().default(null),
    equipement_id: z.string().uuid().nullable().default(null),
  })
  .refine((d) => Boolean(d.intervention_id || d.equipement_id), {
    message: 'Une intervention ou un équipement est requis',
  });
export const schemaActionCoutReseau = z
  .object({
    action: z.enum(['reviser', 'engager', 'facturer', 'valider', 'rejeter', 'annuler']),
    version: z.number().int().positive(),
    motif: z.string().trim().min(3).max(1000),
    montant: z.number().int().min(0).max(100000000000).optional(),
  })
  .superRefine((d, c) => {
    if ((d.action === 'reviser') !== (d.montant !== undefined))
      c.addIssue({
        code: 'custom',
        message: 'Le montant est renseigné uniquement pour une révision',
      });
  });
